/* __next_internal_client_entry_do_not_use__ default auto */ import createTheme from "./createTheme.js";
const defaultTheme = createTheme();
export default defaultTheme;
